import { useMemo } from 'react';
import { getDirectusAPI } from '../utils';

export const useDirectusAPI = () => {
  return useMemo(() => {
    return getDirectusAPI();
  }, []);
};
